import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
	selector: 'app-new-version-dialog',
	imports: [TranslocoDirective],
	templateUrl: './new-version-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './new-version-dialog.component.scss',
})
export class NewVersionDialogComponent {
	dialogRef = inject(MatDialogRef);

	reload() {
		this.dialogRef.close();
		const url = new URL(window.location.href);
		if (url) {
			url.searchParams?.set('v', Date.now().toString());
			window?.location?.replace(url.toString());
		}
	}
}
